import { Text } from '#app/components/Primitives/Text.js';
import {
  CloseIcon,
  SearchIcon as SearchIconOriginal,
} from '@contra/icons/icons';
import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const InputRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    gap: 10px;
    padding: 16px;

    ${theme.mediaQueries.sm} {
      display: block;
      padding: unset;
    }
  `}
`;

const InputContainer = styled.div`
  display: block;
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(SearchIconOriginal)`
  ${({ theme }) => css`
    position: absolute;
    top: calc(50% - 12px);
    left: 16px;

    ${theme.mediaQueries.sm} {
      display: none;
    }
  `}
`;

const MobileCloseButton = styled.button`
  ${({ theme }) => css`
    background: unset;
    border: unset;

    ${theme.mediaQueries.sm} {
      display: none;
    }
  `}
`;

const DoneText = styled(Text)``;

export const DialogSelectInputGroup = ({
  children,
  hideSearchIcon = true,
  onClose,
  withDoneText,
}: {
  readonly children?: ReactNode;
  readonly hideSearchIcon?: boolean;
  readonly onClose: () => void;
  readonly withDoneText?: boolean;
}) => {
  return (
    <InputRow>
      <InputContainer>
        {hideSearchIcon ? null : <SearchIcon size={24} />}
        {children}
      </InputContainer>
      <MobileCloseButton
        aria-label="Close Menu"
        onClick={onClose}
        type="button"
      >
        {withDoneText ? (
          <DoneText textStyle="text-xs-semi-bold">Done</DoneText>
        ) : (
          <CloseIcon size={24} />
        )}
      </MobileCloseButton>
    </InputRow>
  );
};
